module.exports = __webpack_public_path__ + "static/intertec_screen_6-fb725e2c2681e3a7664865544bdfe1a8.jpg";